import type { ProductCardProps } from '@coursera/cds-core';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const getStatusTagRedesignExperimentVariant = (): {
  statusTagRedesignVariant: 'control' | 'A';
  productCardExperimentVariant: ProductCardProps['experimentVariant'];
} => {
  const showRedesignedCard = GrowthDiscoveryEpicClient.preview('productCardPills4b');
  const productCardExperimentVariant: ProductCardProps['experimentVariant'] = showRedesignedCard
    ? 'test1.3'
    : 'control';
  return { statusTagRedesignVariant: showRedesignedCard ? 'A' : 'control', productCardExperimentVariant };
};

export const makeImpressionInStatusTagRedesign = () => {
  GrowthDiscoveryEpicClient.get('productCardPills4b');
};
